export default __webpack_public_path__ + "static/image1-c9ea3a2121ad7bceca40beb7d29d6080.jpg";